import React from "react";
import { useParams } from "react-router-dom";
import Layout from "../../Layout";
import CallDetails from "../../containers/CallDetails";

export default function CallDetailsPage() {
  const { callId } = useParams();

  return (
    <Layout>
      <CallDetails callId={callId} />
    </Layout>
  );
}
